import { Col, Container, Row } from 'react-bootstrap';

const Hero = () => {
    return (
        // <section className="hero-4   pb-6 pt-2">
        //     <Container>
        //         <Row className="justify-content-center">
        //             <Col lg={8} className="text-center">
        //                 <h1 className="hero-title mb-0">Contact Us</h1>
        //                 <p className=" fs-17s text-muted">
        //                     Please fill out the following form and we will get back to you shortly
        //                 </p>
        //             </Col>
        //         </Row>
        //     </Container>

        // </section>


        <section
            style={{
                background: "linear-gradient(135deg, #e3f2fd 0%, #e8f0ff 100%)",
                padding: "80px 0",
                textAlign: "center",
                borderBottomLeftRadius: "30px",
                borderBottomRightRadius: "30px",
                marginLeft: 25,
                marginRight: 25
            }}     >
            {/* <h1 style={{ fontSize: "48px", fontWeight: "700", color: "#1b1f29", }}  >
                Contact Us
            </h1> */}

            <h1
                style={{
                    fontSize: "48px",
                    fontWeight: 700,
                    background: "linear-gradient(90deg, #3b82f6, #60a5fa, #93c5fd)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                }}
            >
                Contact Us
            </h1>

            <p style={{ marginTop: "10px", fontSize: "18px", color: "#6c757d", }}   >
                Please fill out the following form and we will get back to you shortly
            </p>
        </section>
    );
};

export default Hero;
